// src\themes\lino\elements\Header\MainContentWrapper.tsx
import { ReactNode } from 'react';
import HeaderSpacer from './HeaderSpacer';

type MainContentWrapperProps = {
    children: ReactNode;
};

export default function MainContentWrapper({ children }: MainContentWrapperProps) {
    return (
        <div className="min-h-full">
            <HeaderSpacer />
            {children}
        </div>
    );
}